var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 13.3095,
    rx: 0.75,
    fill: "#15195A",
    stroke: "#15195A",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87989 9.47103H7.54834L8.38118 4.63745H9.71266L8.87989 9.47103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7067 4.75559C13.444 4.65779 13.0275 4.5498 12.5124 4.5498C11.1974 4.5498 10.2715 5.20796 10.2658 6.14892C10.2549 6.84316 10.9288 7.22876 11.4328 7.46024C11.9479 7.69678 12.123 7.85117 12.123 8.06202C12.1178 8.38583 11.7068 8.53509 11.3234 8.53509C10.7918 8.53509 10.5069 8.45814 10.0741 8.27798L9.89873 8.20075L9.7124 9.28579C10.0247 9.41933 10.6001 9.53784 11.1974 9.54304C12.5946 9.54304 13.5042 8.89506 13.515 7.89232C13.5203 7.34208 13.1644 6.92046 12.3973 6.57594C11.9315 6.35478 11.6463 6.20565 11.6463 5.97936C11.6518 5.77365 11.8876 5.56294 12.4133 5.56294C12.8462 5.55262 13.1642 5.65028 13.4052 5.74802L13.5256 5.79934L13.7067 4.75559Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0903 4.63745H17.1203L18.1945 9.47096H16.9616C16.9616 9.47096 16.8409 8.91559 16.8027 8.7459H15.0931L14.8137 9.47096H13.4165L15.3943 5.0385C15.5314 4.7248 15.7727 4.63745 16.0903 4.63745ZM16.0083 6.40627C16.0083 6.40627 15.5863 7.48098 15.4767 7.75866H16.5834C16.5287 7.517 16.2765 6.36 16.2765 6.36L16.1835 5.94351C16.1443 6.05076 16.0876 6.19822 16.0494 6.29767C16.0235 6.36508 16.006 6.41044 16.0083 6.40627Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77875 4.63745H3.92108C4.21146 4.64763 4.44709 4.73505 4.52376 5.04376L4.98948 7.26522C4.98944 7.26512 4.9894 7.26502 4.98936 7.26492C4.98937 7.26495 4.98938 7.26498 4.98939 7.26501L5.13189 7.93349L6.43591 4.63745H7.84391L5.75095 9.4659H4.34288L3.15605 5.26589C2.7466 5.04122 2.2793 4.86052 1.75684 4.73512L1.77875 4.63745Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1948bd5d4c115cdf8d3a157a47279936.svg";
export { ForwardRef as ReactComponent };